import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LogService } from '../log.service';
import { AccountService } from '../account.service';
import { BackendService, Message } from '../backend.service';

export class Gender {
  ID: number;
  Name: string;
}

@Injectable({
  providedIn: 'root'
})
export class GenderService {
  private genders: Gender[];
  private backendResponse: Message;

  constructor(private backend: BackendService,
    private log: LogService,
    private account: AccountService) {}

  private ParseGenderFromResponse(gendersNotification$: Subject<Gender[]>) {
    this.genders = [];

    if (this.backendResponse.Code === 200) {
      this.backendResponse.Payload.forEach(element => {
        this.genders.push({
          ID: element[0],
          Name: element[1]
        });
      });
    }
    gendersNotification$.next(this.genders);
  }

  public GetAll(): Observable<Gender[]> {
    const gendersNotification$ = new Subject<Gender[]>();
    const account = this.account.GetAccountData();
    const request = JSON.stringify({
      operation: 'GET',
      resource: 'BowHunter/Gender',
      username: account.username,
      password: account.password
    });

    this.backend.sendRequest(request).subscribe(
      (msg: Message) => {
        this.backendResponse = msg;
        this.ParseGenderFromResponse(gendersNotification$);
      },
      error => {
        this.log.LogError(error);
      }
    );

    return gendersNotification$;
  }
}
